'use client'
import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { IVehicleRequest, ILogin, IPaginationOptions, IUser, User, Vehicle, Trip, ApiResponse, VEHICLE_STATUS, USER_STATUS } from "./types";
import { BASE_URL } from "./constants";
import {clearSession} from "./utils";
export class ApiClient {
    ACCESS_TOKEN: string | null = null;
    constructor(accessToken?: string) {
        if (accessToken) this.ACCESS_TOKEN = accessToken
    }
    get = async (endpoint: string): Promise<ApiResponse> => {
        var headersConfig: AxiosRequestConfig = {
            headers: {
                ContentType: 'application/json',
                Authorization: this.ACCESS_TOKEN && this.ACCESS_TOKEN != '' ? `Bearer ${this.ACCESS_TOKEN}` : ''
            }
        }
        try {
            const response = await axios.get(`${BASE_URL}${endpoint}`, headersConfig);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }

    put = async (endpoint: string, data: any, options?: any): Promise<ApiResponse> => {
         var headersConfig: AxiosRequestConfig = {
            headers: {
                ContentType: 'application/json',
                Authorization: this.ACCESS_TOKEN && this.ACCESS_TOKEN != '' ? `Bearer ${this.ACCESS_TOKEN}` : ''
            }
        }

        try {
            const response = await axios.put(`${BASE_URL}${endpoint}`, data, headersConfig);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    patch = async (endpoint: string, data: any, options?: any): Promise<ApiResponse> => {
        var headersConfig: AxiosRequestConfig = {
            headers: {
                ContentType: 'application/json',
                Authorization: this.ACCESS_TOKEN && this.ACCESS_TOKEN != '' ? `Bearer ${this.ACCESS_TOKEN}` : ''
            }
        }
        
        try {
            const response = await axios.patch(`${BASE_URL}${endpoint}`, data, headersConfig);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    post = async (endpoint: string, data: any, options?: any): Promise<ApiResponse> => {
         var headersConfig: AxiosRequestConfig = {
            headers: {
                ContentType: 'application/json',
                Authorization: this.ACCESS_TOKEN && this.ACCESS_TOKEN != '' ? `Bearer ${this.ACCESS_TOKEN}` : ''
            }
        }
            console.log("🚀 ~ ApiClient ~ headersConfig.headers:", headersConfig.headers)
        try {
            const response = await axios.post(`${BASE_URL}${endpoint}`, data, headersConfig);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }

    delete = async (endpoint: string): Promise<ApiResponse> => {
        var headersConfig: AxiosRequestConfig = {
            headers: {
                ContentType: 'application/json',
                Authorization: this.ACCESS_TOKEN && this.ACCESS_TOKEN != '' ? `Bearer ${ this.ACCESS_TOKEN }` : ''
            }
        }
        try {
            const response = await axios.delete(`${ BASE_URL }${ endpoint }`, headersConfig);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }

    login = async (path: string, body: ILogin): Promise<ApiResponse> => {
        const login = await this.post(path, body);
        return login;
    }

    getMenuActions = async (position: number): Promise<ApiResponse> => {
        const actions = await this.get(`/actions/${position}`);
        return actions;
    }

    getActiveUsers = async () => {
        const response = await this.get(`/users/active-users`);
        return response.data;
    }
    getUsers = async (options?: IPaginationOptions) => {
        const page = options && options.page ? options.page : 1;
        const take = options && options.take ? options.take : 20;
        const users = await this.get(`/users?page=${page}&take=${take}`);
        return users;
    }

    getDeletedUsers = async (options?: IPaginationOptions) => {
        const page = options && options.page ? options.page : 1;
        const take = options && options.take ? options.take : 20;
        const users = await this.get(`/users/deleted`);
        return users;
    }
    restoreUser = async (userId: number): Promise<ApiResponse> => {
        const response = await this.get(`/users/restore/${userId}`);
        return response;
    }

    deleteUser = async (userId: number): Promise<ApiResponse> => {
        const response = await this.post(`/users/${ userId }`, {});
        return response;
    }
    getUserDetails = async (userId: number) => {
        const user = await this.get(`/users/${userId}`);
        return user;
    }
    addUser = async (data: IUser) => {
        const axios = await this.post('/users/add', data);
        return axios;
    }
    updateUser = async (data: IUser, userId: number) => {
        console.log("🚀 ~ ApiClient ~ updateUser= ~ data:", data)
        if (data.password == "") {
            delete data.password
        }
        console.log("🚀 ~ ApiClient ~ updateUser= ~ data:", data)
        try {
            const axios = await this.patch(`/users/${userId}`, data);
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: `${axios.data.response}. Please login for changes to reflect`
            }
        }
        catch (e: any) {
            return {
                status: 400,
                statusText: 'Bad Request',
                data: `Error: ${e}`
            }
        }

    }
    getVehicles = async () => {
        const vehicles = await this.get(`/vehicles`);
        return vehicles.data;
    }
    getVehicleDetails = async (id: number) => {
        const vehicle = await this.get(`/vehicles/${id}`);
        return vehicle;
    }
    createVehicle = async (body: Partial<Vehicle>): Promise<ApiResponse> => {

        try {
            const axios = await this.post(`/vehicles/add`, body);
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data.response
            }
        }
        catch (e: any) {
            return {
                status: 400,
                statusText: 'Bad Request',
                data: `Error: ${e}`
            }
        }
    }
    updateVehicle = async (body: Partial<Vehicle>): Promise<ApiResponse> => {

        try {
            const axios = await this.put(`/vehicles/${body.id}`, body);
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data.response
            }
        }
        catch (e: any) {
            return {
                status: 400,
                statusText: 'Bad Request',
                data: `Error: ${e}`
            }
        }
    }
    getAvailableVehicles = async (request?: IVehicleRequest): Promise<Vehicle[]> => {
        let availableVehicles: Vehicle[] = []
        try {
            const axios = await this.getVehicles();
            const vehicles = axios.vehicles;
            availableVehicles = vehicles.filter((vehicle: Vehicle) => vehicle.in_use !=3);
            if(request && request.type == 0) availableVehicles = vehicles.filter((vehicle: Vehicle) => vehicle.in_use == 0);
            return availableVehicles;
        }
        catch (e: any) {
            return availableVehicles;
        }

    }
    getAvailableVehiclesForRefuel = async (request?: IVehicleRequest): Promise<Vehicle[]> => {
        let availableVehicles: Vehicle[] = []
        try {
            const data = await this.getVehicles();
                const vehicles = data.vehicles;
                    availableVehicles = vehicles.filter((vehicle: Vehicle) => vehicle.in_use != VEHICLE_STATUS.DISPOSED);
                return availableVehicles;
        }
        catch (e: any) {
            return availableVehicles;
        }
        return availableVehicles;
    }
    getTrips = async (options?: IPaginationOptions) => {
        const page = options && options.page || 1;
        const take = options && options.take || 20
        const trips = await this.get(`/trips?page=${page}&take=${take}`);
        return trips;
    }
    searchTrips = async (query:string,options?: IPaginationOptions) => {
        const page = (options && options.page) || 1;
        const take = (options && options.take) || 20
        const trips = await this.get(`/trips/search${query}&page=${page}&take=${take}`);
        return trips;
    }
    getTripDetail = async (tripId: number) => {
        const trips = await this.get(`/trips/${tripId}`);
        return trips;
    }
    getIncompleteTrips = async (options?: IPaginationOptions): Promise<ApiResponse> => {
        const page = options && options.page || 1;
        const take = options && options.take || 20
        try {
            const trips = await this.get(`/trips/incomplete?page=${page}&take=${take}`);
            return {
                status: trips.status,
                statusText: trips.statusText,
                data: trips.data
            }
        }
        catch (e: any) {
            console.log("🚀 ~ ApiClient ~ e:", e)
            if (e.isAxiosError && e.response.status === 401) {
                clearSession();
            }
            return {
                status: 400,
                statusText: 'Bad Request',
                data: e
            }
        }

    }

    completeTrip = async (trip: Partial<Trip>): Promise<ApiResponse> => {
        let endpoint = `/trips/${trip.id}`;
        try {
            const response = await this.patch(endpoint, trip);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }

    getDriverTrips = async (driverId: number, options?: IPaginationOptions) => {
        const page = (options && options.page) || 1;
        const take = (options && options.take) || 20;
        let endpoint = `/trips/user/${driverId}?page=${page}&take=${take}`;
        const trips = await this.get(endpoint);
        return trips;
    }
    getAvailableDrivers = async (request?: IVehicleRequest): Promise<User[]> => {
        let availableDrivers: User[] = []
        try {
            const axios = await this.get('/users/drivers');
            if (axios.status == 200) {
                const drivers = axios.data.drivers;
                    availableDrivers = drivers.filter((driver: User) => driver.busy === USER_STATUS.AVAILABLE);
            }
        }
        catch (e: any) {
            return availableDrivers;
        }
        return availableDrivers;
    }

    getActiveDrivers = async (): Promise<User[]> => {
        let activeDrivers: User[] = []
        try {
            const axios = await this.get('/users/drivers');
            if (axios.status == 200) {
                const drivers = axios.data.drivers;
                activeDrivers = drivers.filter((driver: User) => driver.busy !== USER_STATUS.DELETED);
            }
        }
        catch (e: any) {
        }
        return activeDrivers
    }
    getNotifications = async (userId: number, options?: IPaginationOptions) => {
        const page = options && options.page || 1;
        const take = options && options.take || 20
        //const notifications = await this.get(`/notifications/${userId}?page=${page}&take=${take}`);
        return [];
    }
    getUnreadNotifications = async (userId: number) => {
        //const notifications = await this.get(`/notifications/unread/${userId}`);
        return []; //notifications;
    }
    getActiveProjects = async () => {
        const projects = await this.get(`/projects/active`);
        return projects;
    }
    getAllProjects = async () => {
        const projects = await this.get(`/projects`);
        return projects;
    }
    getAllFundcodes = async () => {
        const fundcodes = await this.get(`/projects/fundcodes`);
        return fundcodes;
    }
    getActiveFundcodes = async () => {
        const fundcodes = await this.get(`/projects/fundcodes-active`);
        return fundcodes;
    }
    getProjectFundcodes = async (projectCode: string) => {
        const fundcodes = await this.get(`/projects/fundcodes/${projectCode}`);
        return fundcodes;
    }
    getLastRequestOnVehicle = async (vehicle: string, request_type: number) => {
        const axios = await this.get(`/last_request/${vehicle}?type=${request_type}`)
        return axios;
    }
    getVehicleHistory = async (vehicle: string, requestType: number, requestId?: number,) => {
        console.log("🚀 ~ ApiClient ~ getVehicleHistory= ~ requestType:", requestType);
        let endpoint = `/history/${vehicle}?type=${requestType}`;
        if (requestId) endpoint = `${endpoint}&rid=${requestId}`
        const axios = await this.get(endpoint);
        return axios;
    }
    getPositions = async () => {
        const axios = await this.get('/users/positions');
        return axios.data.positions;
    }
    getDepartments = async () => {
        const axios = await this.get('/departments');
        return axios.data.departments;
    }

    getVehicleTripLog = async (vehicle: string) => {
        const axios = await this.get(`/trips/vehicle/${vehicle}`)
        return axios
    }

    //get suppliers
    getSuppliers = async (data?: any): Promise<ApiResponse> => {
        const endpoint = data?.location ? `/suppliers?location=${data.location}` : `/suppliers`;
        try {
            const response = await this.get(endpoint);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }


    //get active suppliers
    getAllSuppliers = async (): Promise<ApiResponse> => {
        const endpoint = `/suppliers`;
        try {
            const response = await this.get(endpoint);
            return {
                status: response.status,
                statusText: response.statusText,
                data: response.data.suppliers
            }
        }
        catch (e: any) {
            const error = e as unknown as AxiosError;
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: []
            }
        }
    }
    updateSupplier = async (data: any): Promise<ApiResponse> => {
        try {
            const axios = await this.put(`/suppliers/${data.id}`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    createSupplier = async (data: any): Promise<ApiResponse> => {
        try {
            const axios = await this.post(`/suppliers`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    updateDepartment = async (data: any): Promise<ApiResponse> => {
        try {
            const axios = await this.put(`/departments/${data.id}`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    createDepartment = async (data: any): Promise<ApiResponse> => {
        try {
            const axios = await this.post(`/departments`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    createProject = async (data: any): Promise<ApiResponse> => {
        try {
            const axios = await this.post(`/projects`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    updateProject = async (data: any): Promise<ApiResponse> => {
        try {
            const axios = await this.put(`/projects/${data.id}`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    updateFundcode = async (data: any): Promise<ApiResponse> => {

        try {
            const axios = await this.put(`/fundcodes/${data.id}`, data)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
    createFundcode = async (data: any): Promise<ApiResponse> => {
        const expiration = Date.parse(data.expiration) / 1000;
        delete data.expiration
        const postData = {
            ...data,
            expiration: expiration
        }
        console.log("🚀 ~ ApiClient ~ createFundcode= ~ postData:", postData)
        try {
            const axios = await this.post(`/projects/fundcodes`, postData)
            return {
                status: axios.status,
                statusText: axios.statusText,
                data: axios.data
            }
        }
        catch (error: any) {
            return {
                status: error.isAxiosError ? error.status! : 400,
                statusText: error.isAxiosError ? error.code! : 'Bad Request',
                data: error.response
            }
        }
    }
}
